var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"popoverInnerClass":"w-100 h-100"}},[_vm._t("title"),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"app-color-picker-trigger",style:(("background-color: " + _vm.value))}),_vm._t("caption"),_c('template',{slot:"popover"},[_c('ColorPicker',{attrs:{"value":_vm.value},on:{"input":function (ref) {
	var hex = ref.hex;

	return _vm.$emit('input', hex);
}}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }